import { Store } from "../../types";
import ActivityLogView from "./ActivityLogView";
import { STORE_LOG_ENTITY_TYPES } from "./logUtils";
import activityIcon from "../../assets/management/history.svg";

type StoreActivityTabProps = {
    store: Store;
};

export default function StoreActivityTab({ store }: StoreActivityTabProps) {
    return (
        <div className="store-activity">
            <ActivityLogView
                storeId={store.id}
                entityTypes={STORE_LOG_ENTITY_TYPES}
                heading={
                    <div className="store-activity__title">
                        <p>Shopify Stores/{store.friendlyName}</p>
                        <h1><img src={activityIcon} alt="" />Activity</h1>
                    </div>
                }
            />
        </div>
    );
}
